<div id="attractions" class="nearby-places-section nbp-1">
  <h2 style="color: #000;" class="features-heading">NEARBY PLACES<br>
    <span class="sub-head-span" style="color: #379237">The Greenstar Inn (Near Biju Pattanaik Airport)</span></h2>
  <!-- <h2 class="section-heading">Greenstar Inn Nearby Places <br>(Near Biju Pattanaik Airport , Bhubaneswar)</h2> -->
  <div class="unique-cards-container">
    <div class="card unique-card">
      <img src="assets/images/Railway Station.jpg" class="card-img-top" alt="Railway station">
      <div class="card-body">
        <p class="card-text">Railway Station</p>
        <span class="text-muted">Distance From Hotel to Railway station <strong> 3.4 km (10 min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Airport.jpg" class="card-img-top" alt="Airport">
      <div class="card-body">
        <p class="card-text">biju pattnaik  airport </p>
        <span class="text-muted">Distance From Hotel to airport <strong> 1.4 km (4 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Busstop.jpg" class="card-img-top" alt="Bus Stop">
      <div class="card-body">
        <p class="card-text">Babasaheb Bhim Rao Ambedkar Bus Terminal </p>
        <span class="text-muted">Distance From Hotel to Babasaheb Bhim Rao Ambedkar Bus Terminal <strong> 4.8 km (12
            min)</strong> </span>

      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Esplanade.jpg" class="card-img-top" alt="Esplanade Mall">
      <div class="card-body">
        <p class="card-text">Esplanade Mall</p>
        <span class="text-muted">Distance From Hotel to Esplanade Mall <strong> 7.1 km (17 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Symphony Mall.jpg" class="card-img-top" alt="Symphony Mall">
      <div class="card-body">
        <p class="card-text">Symphony Mall</p>
        <span class="text-muted">Distance From Hotel to Symphony Mall <strong> 12 km (23 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Rammandir.jpg" class="card-img-top" alt="Shri Ram Temple">
      <div class="card-body">
        <p class="card-text">Shri Ram Temple</p>
        <span class="text-muted">Distance From Hotel to Shri Ram Temple <strong> 4.3 km (10 min)</strong> </span>

      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Dhauli.webp" class="card-img-top" alt="Dhauligiri">
      <div class="card-body">
        <p class="card-text">Dhauli Shanti Stupa</p>
        <span class="text-muted">Distance From Hotel to Dhauli Shanti stupa <strong> 12 km (24 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Khandagiri.jpg" class="card-img-top" alt="Khandagiri and Udayagiri Caves">
      <div class="card-body">
        <p class="card-text">Khandagiri and Udayagiri Hills</p>
        <span class="text-muted">Distance From Hotel to Khandagiri and Udayagiri Hills <strong> 5.8km (13
            min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Nadankanan.jpg" class="card-img-top" alt="Nadankanan">
      <div class="card-body">
        <p class="card-text">Nadankanan Zoological Park</p>
        <span class="text-muted">Distance From Hotel to Nadankanan Zoological Park <strong> 17 km (32 min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Botanical Garden.jpg" class="card-img-top" alt="State Botanical Garden">
      <div class="card-body">
        <p class="card-text">State Botanical Garden</p>
        <span class="text-muted">Distance From Hotel to State Botanical Garden <strong> 19 km (37 min)</strong></span>
      </div>
    </div>
  </div>
</div>

<div id="attractions" class="nearby-places-section">
  <h2 style="color: #000;" class="features-heading">NEARBY PLACES<br>
    <span class="sub-head-span" style="color: #379237">The Greenstar Premium (Near Sum Hospital)</span></h2>
  <!-- <h2 class="section-heading">Greenstar Inn Premium Nearby Places <br>(Near Sum Hospital , Bhubaneswar)</h2> -->
  <div class="unique-cards-container">
    <div class="card unique-card">
      <img src="assets/images/Railway Station.jpg" class="card-img-top" alt="Railway station">
      <div class="card-body">
        <p class="card-text">Railway Station</p>
        <span class="text-muted">Distance From Hotel to Railway station <strong> 10.1 km (23 min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Airport.jpg" class="card-img-top" alt="Airport">
      <div class="card-body">
        <p class="card-text">biju pattnaik  airport </p>
        <span class="text-muted">Distance From Hotel to airport <strong> 7.5 km (18 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Busstop.jpg" class="card-img-top" alt="Bus Stop">
      <div class="card-body">
        <p class="card-text">Babasaheb Bhim Rao Ambedkar Bus Terminal </p>
        <span class="text-muted">Distance From Hotel to Babasaheb Bhim Rao Ambedkar Bus Terminal <strong> 4.8 km (12
            min)</strong> </span>

      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Esplanade.jpg" class="card-img-top" alt="Esplanade Mall">
      <div class="card-body">
        <p class="card-text">Esplanade Mall</p>
        <span class="text-muted">Distance From Hotel to Esplanade Mall <strong> 11.1 km (25 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Symphony Mall.jpg" class="card-img-top" alt="Symphony Mall">
      <div class="card-body">
        <p class="card-text">Symphony Mall</p>
        <span class="text-muted">Distance From Hotel to Symphony Mall <strong> 13.9 km (35 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Rammandir.jpg" class="card-img-top" alt="Shri Ram Temple">
      <div class="card-body">
        <p class="card-text">Shri Ram Temple</p>
        <span class="text-muted">Distance From Hotel to Shri Ram Temple <strong> 9.2 km (20 min)</strong> </span>

      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Dhauli.webp" class="card-img-top" alt="Dhauligiri">
      <div class="card-body">
        <p class="card-text">Dhauli Shanti Stupa</p>
        <span class="text-muted">Distance From Hotel to Dhauli Shanti stupa <strong> 19.5km (40 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Khandagiri.jpg" class="card-img-top" alt="Khandagiri and Udayagiri Caves">
      <div class="card-body">
        <p class="card-text">Khandagiri and Udayagiri Hills</p>
        <span class="text-muted">Distance From Hotel to Khandagiri and Udayagiri Hills <strong> 6.4km (14
            min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Nadankanan.jpg" class="card-img-top" alt="Nadankanan">
      <div class="card-body">
        <p class="card-text">Nadankanan Zoological Park</p>
        <span class="text-muted">Distance From Hotel to Nadankanan Zoological Park <strong> 20.6km (45
            min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Botanical Garden.jpg" class="card-img-top" alt="State Botanical Garden">
      <div class="card-body">
        <p class="card-text">State Botanical Garden</p>
        <span class="text-muted">Distance From Hotel to State Botanical Garden <strong> 17.5 km (30 min)</strong></span>
      </div>
    </div>
  </div>
</div>
